import { PropsWithChildren } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import { twMerge } from "tailwind-merge";

import { ErrorText } from "~/common/components";
import { replaceUnderscores } from "~/common/utils";
import RadioButtonOption from "~/patients/components/ui/RadioButtonOption";
import { ConsultationInputLayout } from "~/providers/components";

interface RadioOptionFieldProps extends PropsWithChildren {
  label: string;
  options: readonly string[];
  register: UseFormRegisterReturn;
  error?: string;
  isDisabled: boolean;
}

export const RadioOptionField = ({
  label,
  options,
  children,
  register,
  error,
  isDisabled,
}: RadioOptionFieldProps) => (
  <ConsultationInputLayout label={label}>
    <div className="flex w-full flex-col gap-2.5">
      <div className={twMerge("flex flex-col", error && "gap-2")}>
        <div className="flex w-full flex-col gap-3">
          {options.map((value) => (
            <RadioButtonOption
              key={value}
              label={replaceUnderscores(value)}
              variant="simple"
              containerClassName="w-auto"
              value={value}
              disabled={isDisabled}
              {...register}
            />
          ))}
        </div>
        {error && <ErrorText>{error}</ErrorText>}
      </div>
      {children}
    </div>
  </ConsultationInputLayout>
);
